@use '/src/shared/assets/break-points' as *;
@use './vars' as *;


.layoutGrid {
  display: grid;
  width: 100dvw;
  height: 100dvh;
  margin-left: 0;
  overflow: hidden;

  &.transition {
    transition-property: grid-template-rows;
    transition-duration: $transitionDuration;
  }

  grid-template-columns: $sidebarWidth 1fr auto;
  grid-template-rows: auto 1fr;
  grid-template-areas:
        "logo header userbar"
        "bottom bottom bottom";

  @media (max-width: $md) {
    grid-template-columns: $sidebarWidth 1fr min-content;

    grid-template-areas:
		"logo header userbar"
		"bottom bottom bottom";
  }

  @media (max-width: $sm) {
    grid-template-columns: 1fr;
    grid-template-rows: /*auto*/ auto auto 1fr;
    grid-template-areas:
        /*"logo"*/
        "header"
        "userbar"
        "bottom";
  }
}

.showSidebarColInLayout {
  grid-template-columns: $sidebarWidth 1fr auto;
}

.hideSidebarColInLayout {
  grid-template-columns: 0 1fr auto;
}

.layoutBottom {
  grid-area: bottom;
  display: grid;
  grid-template-rows: auto 1fr;
  overflow: hidden;
  grid-template-areas:
		"sidebar topbar"
		"sidebar content_footer";

  &.transition {
    transition: grid-template-columns $transitionDuration;
  }

  @media (max-width: $sm) {
    grid-template-columns: 1fr;
    grid-template-areas:
			"topbar"
			"content_footer";
  }
}

.logo {
  position: relative;
  grid-area: logo;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: $logoTxtLtSpc;

  border-right: 1px solid $borderColor;
  border-bottom: 1px solid $borderColor;

  &.transition {
    transition-property: font-size, padding;
    transition-duration: $transitionDuration;
  }

  a {
    h1 {
      transition: font-size $transitionDuration;
      padding: 0;
      font-weight: normal;
      font-size: 2.3rem;
    }

    width: 100%;
    text-align: center;

    color: #2858a9;
    user-select: none;
    text-decoration: none;
  }

  @media (max-width: $sm) {

    display: none;

    a {
      width: auto;
      padding: 0 1rem;
    }

    border: none;
  }
}

.logoCurtain {

  &.hide {
    width: 0;
  }

  background: rgb(30, 67, 128);
  position: relative;
  grid-area: logo;
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: $logoTxtLtSpc;
  border-bottom: 1px solid #4c6293;

  &.transition {
    transition-property: width, font-size, padding, height, border-bottom-color;
    transition-duration: $transitionDuration;
  }

  a {
    h1 {
      transition: font-size $transitionDuration;
      padding: 0;
      font-weight: normal;
      transition-property: color;
      transition-duration: $transitionDuration;
      font-size: 2.3rem;
    }

    position: absolute;
    width: $sidebarWidth;
    left: 0;
    text-align: center;

    color: white;
    user-select: none;
    text-decoration: none;
  }

  @media (max-width: $sm) {
    display: none;
  }
}

.menuButton {

  &.if-show-curtain {
    transition-delay: calc($transitionDuration * 0.4);
    margin-left: calc($sidebarWidth - 4rem);
  }

  z-index: 1001;
  position: absolute;
  transition: margin-left $transitionDuration;
  transition-delay: 0s;
  left: 0;
  margin-left: 1.25rem;

  button {
    width: 2rem;
  }

  span {
    font-size: 2rem;
  }

  /*@media (max-width: $sm) {
    position: relative;
  }*/

  @media (min-width: $sm) {
    display: none;
  }
}

.header {
  display: flex;
  align-items: center;
  grid-area: header;
  border-right: 1px solid $borderColor;
  border-bottom: 1px solid $borderColor;
  padding: 0.5rem 5rem 0.5rem 5rem;
  overflow: hidden;

  & > div > * {
    padding: 0.25rem 0;
  }

  @media (max-width: $md) {
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  & .org-name {
    text-decoration: none;

    div {
      padding: 0;
      font-size: 1.15rem;
      color: #575d6d;
    }

    @media (max-width: $md) {
      display: none;
    }
  }

  & .title {

    overflow: hidden;

    a {
      text-decoration: none;
      color: #575d6d;
      font-size: inherit;
    }

    @media (max-width: $md) {
      display: none;
    }
  }

  & .subtitle {
    font-size: 1.6rem;
    color: #2858a9;
    display: block;
    hyphens: auto;

    @media (max-width: $md) {
      display: none;
    }
  }
}

.userbar {
  grid-area: userbar;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 4rem;
  border-bottom: 1px solid $borderColor;

  @media (max-width: $sm) {
    justify-content: stretch;
  }
}

.contentFooterContainer {
  grid-area: content_footer;
  display: grid;
  grid-template-rows: 1fr auto;
  grid-template-columns: 1fr;
  grid-template-areas:
		"content"
		"footer";
  overflow: auto;
}

.content {
  min-width: 0;
  grid-area: content;
  flex: 1 1 auto;
  transition: opacity $transitionDuration;
  padding: 2rem 4rem;
  opacity: 1;

  @media (max-width: $md) {
    padding: 1rem 2rem;
  }
}

.sidebar {
  color: white;
  position: relative;
  width: $sidebarWidth;
  display: flex;
  flex-direction: column;

  overflow: hidden;
  grid-area: sidebar;
  background: linear-gradient(
                  to bottom,
                  rgb(30, 67, 128) 0px,
                  rgb(30, 67, 128) 50%,
                  rgb(48, 105, 202) 100%
  );

  &.transition {
    transition-property: margin-left;
    transition-duration: $transitionDuration;
  }

  margin-left: 0;

  &.hide {
    margin-left: -$sidebarWidth;
  }

  @media (max-width: $sm) {
    grid-area: unset;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 1000;
  }

  & .pwaVersion {
    position: absolute;
    z-index: 1000;
    font-size: 0.75rem !important;
    left: 0.5rem;
    bottom: 0.5rem;
    color: white !important;
    opacity: 0.25 !important;
  }
}

.sidebarBGDarkArea {
  position: absolute;

  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  z-index: 999;
  background: rgba(0, 0, 0, 0);
  transition: background-color $transitionDuration;
  pointer-events: none;

  @media (min-width: $sm) {
    display: none;
  }
}

.showSidebarBGDarkArea {
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.5);
}

.sidebarNav {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: $sidebarWidth;
  flex: 1 1 auto;
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  margin-top: 2.75rem;

  @media (max-width: $sm) {
    /*margin-top: 3.7rem;*/
    margin: 0;
  }

  & .linkList {
    text-align: left;
    margin: 0.5rem 0 0;
    padding: 0;
    list-style-type: none;
    position: relative;
    width: $sidebarWidth;
    flex: 0 1 auto;
    overflow-y: auto;
    overflow-x: hidden;
  }
}

.topbar {
  grid-area: topbar;
  transition: height, max-height, opacity;
  transition-duration: $transitionDuration;
  z-index: 50;
  display: flex;
  justify-content: space-between;
  background: #f9fafe;
  align-items: center;
  flex: 0 0 auto;
  overflow: hidden;
  border-bottom: 1px solid $borderColor;
  position: relative;
  opacity: 1;

  @media (max-width: $sm) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  &.hide {
    opacity: 0;
  }
}

.breadcrumbs {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.5rem 0.5rem 0;

  &.menu {
    flex-direction: column;
    align-items: flex-start;
  }

  & .topbarBackButton {
    width: 2rem !important;
    height: 2rem !important;
    margin: 0 1rem 0 1.5rem !important;
    position: relative !important;
  }

  & span > * {
    text-decoration: none;
    /*margin-right: 0.25rem;
    font-size: 1rem;*/
  }

  & a:hover {
    color: #4c6293;
  }

  & a[data-is-last-link="true"] {
    color: black;
    cursor: default;
  }

  & .breadcrumb {

    /*flex: 1 1 0;*/
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
    transition: max-height $transitionDuration;

    & a {
      text-decoration: none;
    }

    /*&:not(:last-of-type) a {
      text-decoration: underline;
    }*/

    & .lastBreadcrumbLink {
      color: black;
      cursor: default;
    }
  }
}

.topbarAdditionalInfoCss {
  flex: 0 1 auto;
  padding: 0.5rem 2rem;
  justify-content: center;
  text-align: center;

  @media (max-width: $sm) {
    border-top: 1px solid #dce3ec;
    border-left: none;
    padding: 0.5rem 2rem 0.5rem 2rem;
    margin: 0;
    width: 100%;
    justify-content: flex-start;
    text-align: left;
  }
}

.footer {
  grid-area: footer;
  z-index: 0;
  display: flex;
  flex-direction: column;
  border-top: 1px solid rgb(220, 227, 236);

  & > div {
    padding: 0 4rem;

    @media (max-width: $md) {
      padding: 0 2rem;
    }
  }

  @media (max-width: $sm) {
    width: 100dvw;
    position: sticky;
    left: 0;
  }
}

.copyright {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 4rem;
  border-top: 1px solid rgb(220, 227, 236);
  overflow: hidden;
  transition-property: background;

  span {
    text-decoration: none;
    color: #575d6d;
  }

  @media (max-width: $sm) {
    display: none;
  }
}

.nav-link {
  text-decoration: none;
  width: 100%;
  padding: 0.5rem 1.5rem 0.5rem 2rem;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.nav-link-container {
  box-sizing: content-box;
  border-left: 0.3rem solid transparent;

  --nav-item-color: white;
  --nav-item-hover-color: #e5e5e5;

  div, a {
    color: var(--nav-item-color);
  }

  &:hover {
    & > div, a {
      color: var(--nav-item-hover-color);
    }
  }

  @media (display-mode: browser) or (display-mode: fullscreen) {
    &:hover {
      background: rgba(255, 255, 255, 0.05);
      border-left: 0.3rem solid #dc1654;
    }
  }
}

.selected-nav-link-container {
  background: rgba(255, 255, 255, 0.05);

  @media (display-mode: standalone) {
    border-left: 0.3rem solid #dc1654;
  }
}
